export const RequestReceipt = ({ result, email }) => (
  <div className="mt-6 border-l-4 border-[#F7C52B] bg-neutral-50 p-5 text-left" data-testid="request-receipt">
    <p className="text-xs font-bold tracking-[0.2em] text-neutral-500">REQUEST ID</p>
    <p className="mt-1 font-mono text-2xl font-bold text-neutral-900" data-testid="request-reference">{result.reference}</p>
    <p className="mt-3 text-sm text-neutral-700" data-testid="request-email-status">
      {result.customer_email_status === 'sent'
        ? `A confirmation email was sent to ${email}.`
        : 'Your request is saved, but we could not send the confirmation email. Keep this request ID — the office can still see your request.'}
    </p>
  </div>
);
